/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './CustomerInfo.scss';

import { object } from 'prop-types';
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import BarSegment from 'components/layouts/Bar/Balance/BarSegment/BarSegment';
import { NON_BREAKING_SPACE } from 'services/Formats';
import { updatedSummitBenefitsEnabled } from 'services/FeatureFlags';

const CustomerName = ({ isMobileLayout, fullName }) => {
  return isMobileLayout ? (
    <div className="customer-title">{fullName}</div>
  ) : (
    <span className="customer-title"> {fullName}</span>
  );
};

const CustomerNameWithPermissions = WithUserPermissions(CustomerName);

const CustomerInfo = ({
  customer,
  isMobileLayout,
  clientTier,
  hideServiceLevel = false
}) => {
  return (
    <BarSegment
      segmentClass="customer-info"
      label={
        <Fragment>
          <span className="customer-title welcome-back">Welcome Back</span>
          <span className="customer-name">
            <CustomerNameWithPermissions
              fullName={customer.fullName}
              isMobileLayout={isMobileLayout}
              shouldMask
            />
          </span>
        </Fragment>
      }>
      {!hideServiceLevel && clientTier && (
        <span className="customer-level">
          {`${clientTier} Member${NON_BREAKING_SPACE}-${NON_BREAKING_SPACE}`}
          {
            <Fragment>
              <Link
                to="/program-benefits"
                className="customer-level view-benefits-link"
                data-metrics-location="BNR">
                { updatedSummitBenefitsEnabled() ? 'View My Summit Household & Benefits' : 'View Benefits' }
              </Link>
            </Fragment>
          }
        </span>
      )}
    </BarSegment>
  );
};

CustomerInfo.propTypes = {
  customer: object
};

export default CustomerInfo;
